"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeAssert = {
    isUndefined: function (value) { return; },
    noUndefined: function (value) { return; },
    isNull: function (value) { return; },
    noNull: function (value) { return; },
    isNumber: function (value) { return; },
    noNumber: function (value) { return; },
    isBoolean: function (value) { return; },
    noBoolean: function (value) { return; },
    isString: function (value) { return; },
    noString: function (value) { return; },
    isNever: function (value) { return; }
};
//# sourceMappingURL=typeAssert.js.map